module.exports = __webpack_public_path__ + "static/media/Jessica.963dcaf9.jpg";